/* eslint-disable max-len */
import { combineSlices } from '@reduxjs/toolkit';

// Account
import activeCartSlice, { ActiveCartState } from './@account/activeCart/activeCartSlice';
import authenticationSlice, { AuthenticationState } from './@account/authentication/authenticationSlice';
import changePasswordSlice, { ChangePasswordState } from './@account/changePassword/changePasswordSlice';
import customerSlice, { CustomerState } from './@account/customer/customerSlice';
import orderDetailSlice, { OrderDetailState } from './@account/orderDetail/orderDetailSlice';
import orderOverviewSlice, { OrderOverviewState } from './@account/orderOverview/orderOverviewSlice';
import registrationSlice, { RegistrationState } from './@account/registration/registrationSlice';
import resetPasswordSlice, { ResetPasswordState } from './@account/resetPassword/resetPasswordSlice';
// Blocks
import serviceSectionSlice, { ServiceSectionState } from './@blocks/serviceSection/serviceSectionSlice';
import topNavbarSlice, { TopNavbarState } from './@blocks/topNavbar/topNavbarSlice';
import urgentBannerSlice, { UrgentBannerState } from './@blocks/urgentBanner/urgentBannerSlice';
// Blog
import blogCategoriesSlice, { BlogCategoriesState } from './@blog/blogCategories/blogCategoriesSlice';
import blogOverviewsSlice, { BlogOverviewsState } from './@blog/blogOverviews/blogOverviewsSlice';
import blogPostSlice, { BlogPostState } from './@blog/blogPost/blogPostSlice';
// Brands
import brandSlice, { BrandState } from './@brands/brand/brandSlice';
import brandsSlice, { BrandsState } from './@brands/brands/brandsSlice';
// Departments
import departmentDetailSlice, { DepartmentDetailState } from './@departments/departmentDetail/departmentDetailSlice';
import departmentOverviewSlice, { DepartmentOverviewState } from './@departments/departmentOverview/departmentOverviewSlice';
// Forms
import giftcardBalanceFormSlice, { GiftcardBalanceFormState } from './@forms/giftcardBalanceForm/giftcardBalanceFormSlice';
import newsletterFormSlice, { NewsletterFormState } from './@forms/newsletterForm/newsletterFormSlice';
import participateFormSlice, { ParticipateFormState } from './@forms/participateForm/participateFormSlice';
// Pages
import customPageSlice, { CustomPageState } from './@pages/customPage/customPageSlice';
import customPagesSlice, { CustomPagesState } from './@pages/customPages/customPagesSlice';
import pagesSlice, { PagesState } from './@pages/pages/pagesSlice';
// Products
import productSlice, { ProductState } from './@products/product/productSlice';
import productCategoriesSlice, { ProductCategoriesState } from './@products/productCategories/productCategoriesSlice';
import productCategorySlice, { ProductCategoryState } from './@products/productCategory/productCategorySlice';
import productDefaultSlice, { ProductDefaultState } from './@products/productDefault/productDefaultSlice';
import productVariantSlice, { ProductVariantState } from './@products/productVariant/productVariantSlice';
// Shop
import cartSlice, { CartState } from './@shop/cart/cartSlice';
import orderSlice, { OrderState } from './@shop/order/orderSlice';
import wishlistSlice, { WishlistState } from './@shop/wishlist/wishlistSlice';
// Stores
import storeSlice, { StoreState } from './@stores/store/storeSlice';
import storesSlice, { StoresState } from './@stores/stores/storesSlice';
// Other
import appSlice, { AppState } from './app/appSlice';
import faqSlice, { FaqState } from './faq/faqSlice';
import meilisearchSlice, { MeilisearchState } from './meilisearch/meilisearchSlice';
import navigationsSlice, { NavigationsState } from './navigations/navigationsSlice';
import spaceSlice, { SpaceState } from './space/spaceSlice';
import toastSlice, { ToastState } from './toast/toastSlice';

export interface Slices {
    // Account
    activeCartSlice: ActiveCartState;
    authenticationSlice: AuthenticationState;
    changePasswordSlice: ChangePasswordState;
    customerSlice: CustomerState;
    orderDetailSlice: OrderDetailState;
    orderOverviewSlice: OrderOverviewState;
    registrationSlice: RegistrationState;
    resetPasswordSlice: ResetPasswordState;
    // Blocks
    serviceSectionSlice: ServiceSectionState;
    topNavbarSlice: TopNavbarState;
    urgentBannerSlice: UrgentBannerState;
    // Blog
    blogCategoriesSlice: BlogCategoriesState;
    blogOverviewsSlice: BlogOverviewsState;
    blogPostSlice: BlogPostState;
    // Brands
    brandSlice: BrandState;
    brandsSlice: BrandsState;
    // Departments
    departmentDetailSlice: DepartmentDetailState;
    departmentOverviewSlice: DepartmentOverviewState;
    // Forms
    giftcardBalanceFormSlice: GiftcardBalanceFormState;
    newsletterFormSlice: NewsletterFormState;
    participateFormSlice: ParticipateFormState;
    // Pages
    customPageSlice: CustomPageState;
    customPagesSlice: CustomPagesState;
    pagesSlice: PagesState;
    // Products
    productSlice: ProductState;
    productCategorySlice: ProductCategoryState;
    productCategoriesSlice: ProductCategoriesState;
    productDefaultSlice: ProductDefaultState;
    productVariantSlice: ProductVariantState;
    // Shop
    cartSlice: CartState;
    orderSlice: OrderState;
    wishlistSlice: WishlistState;
    // Stores
    storeSlice: StoreState;
    storesSlice: StoresState;
    // Other
    appSlice: AppState;
    faqSlice: FaqState;
    meilisearchSlice: MeilisearchState;
    navigationsSlice: NavigationsState;
    spaceSlice: SpaceState;
    toastSlice: ToastState;
}

export default combineSlices(
    // Account
    activeCartSlice,
    authenticationSlice,
    changePasswordSlice,
    customerSlice,
    orderDetailSlice,
    orderOverviewSlice,
    registrationSlice,
    resetPasswordSlice,
    // Blocks
    serviceSectionSlice,
    urgentBannerSlice,
    topNavbarSlice,
    // Blog
    blogCategoriesSlice,
    blogOverviewsSlice,
    blogPostSlice,
    // Brands
    brandSlice,
    brandsSlice,
    // Departments
    departmentDetailSlice,
    departmentOverviewSlice,
    // Forms
    giftcardBalanceFormSlice,
    newsletterFormSlice,
    participateFormSlice,
    // Pages
    customPageSlice,
    customPagesSlice,
    pagesSlice,
    // Products
    productSlice,
    productCategorySlice,
    productCategoriesSlice,
    productDefaultSlice,
    productVariantSlice,
    // Shop
    cartSlice,
    orderSlice,
    wishlistSlice,
    // Stores
    storeSlice,
    storesSlice,
    // Other
    appSlice,
    faqSlice,
    meilisearchSlice,
    navigationsSlice,
    spaceSlice,
    toastSlice,
);
